<template>
  <article>
    <input
      class="form-control"
      type="password"
      :id="id"
      v-on="NOS_INSTANCE.listeners()"
      npkencrypt="on"
      data-keypad-type="number"
      data-keypad-theme="mobile"
      data-keypad-extend-ui="pw"
      data-keypad-next="__hide__"
      maxlength="4"
      :value="validationData"
    />
    <input type="hidden" :value="validationData" />
  </article>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "newAcnoPasswordActionSheet",
  components: {},
  props: {
    id: {
      default: "password",
    },
    NOS_INSTANCE_REFERANCE: {
      required: true,
      default: () => undefined,
    },
  },
  data() {
    return {
      NOS_INSTANCE: {},
      isOpenPassword: false,
    };
  },
  validations() {
    return {
      validationData: { required },
    };
  },
  created() {
    this.NOS_INSTANCE = this.NOS_INSTANCE_REFERANCE;
  },
  mounted() {},
  computed: {
    validationData() {
      if (this.NOS_INSTANCE.noscomponent) {
        return this.NOS_INSTANCE.noscomponent[this.id];
      } else {
        return "";
      }
    },
  },
  methods: {
    init() {
      this.NOS_INSTANCE.noscomponent[this.id] = "";
    },
  },
};
</script>
